module.exports = __webpack_public_path__ + "img/download-3.5c3280c0.jpg";